// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__HJdJi","colored":"Title_colored__zYAp9"};